import { inputTextProps } from '@/assets/props/defaultProps';
export const etc = {
  title: '2. 기타정보',
  inputs: [
    {
      inputName: 'etc_specialty',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '특기',
        },
      },
    },
    {
      inputName: 'etc_hobby',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '취미',
        },
      },
    },
  ]
};